import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import SectionNav from "./components/SectionNav";
import Mission from "./components/Mission";
import Philanthropy from "./components/Philanthropy";
import ThingsWeLike from "./components/ThingsWeLike";
import Conservation from "./components/Conservation";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Navbar />
      <SectionNav />
      <main>
        <Hero />
        <Mission />
        <Philanthropy />
        <ThingsWeLike />
        <Conservation />
      </main>
      <Footer />
    </div>
  );
}